import { Controller } from "@hotwired/stimulus";

// « Bulletins scolaires » filters (owner's request of 08/10/2026): the kind
// of period first — a trimester, a period of the period set, or the year —
// then the list of that kind only. « Annuel » has no list of its own.
export default class extends Controller {
  static targets = ["type", "choice"];

  toggle() {
    const type = this.typeTarget.value;
    this.choiceTargets.forEach((choice) => {
      choice.hidden = choice.dataset.periodType !== type;
    });
  }
}
